module.exports = __webpack_public_path__ + "static/media/icon-live-ic-cancel-gray.de69851d.svg";